import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft, AlertCircle } from "lucide-react";
import * as portalApi from "../../api/payroll/payrollPortalApi";
import PayslipBreakdown from "../../components/payroll/PayslipBreakdown";
import PaymentStatusBadge from "../../components/payroll/PaymentStatusBadge";
import { Card, CardContent, Alert, Skeleton } from "../../components/ui";
import { useToast } from "../../context/ToastContext";

const MONTHS = [
  "",
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

export default function MyPayslipDetail() {
  const { id } = useParams();
  const [payslip, setPayslip] = useState(null);
  const [loading, setLoading] = useState(true);
  const toast = useToast();

  useEffect(() => {
    (async () => {
      try {
        const res = await portalApi.getMyPayslipById(id);
        setPayslip(res.data || res);
      } catch (err) {
        toast.error(err.response?.data?.message || "Failed to load");
      } finally {
        setLoading(false);
      }
    })();
  }, [id]);

  if (loading) {
    return (
      <div className="p-4 sm:p-6 max-w-4xl mx-auto space-y-6">
        <div className="space-y-2">
          <Skeleton height={16} width={100} />
          <Skeleton height={32} width={220} />
        </div>
        <Card>
          <CardContent className="p-6 space-y-4">
            <Skeleton height={40} width="100%" />
            <Skeleton height={120} width="100%" />
            <Skeleton height={80} width="100%" />
          </CardContent>
        </Card>
      </div>
    );
  }

  if (!payslip) {
    return (
      <div className="max-w-4xl mx-auto p-8 text-center text-neutral-500 dark:text-neutral-400 font-semibold text-body-md">
        Payslip not found
      </div>
    );
  }

  return (
    <div className="p-4 sm:p-6 max-w-4xl mx-auto space-y-6">
      {/* Navigation & Header */}
      <div className="pb-4 border-b border-neutral-200 dark:border-neutral-800">
        <Link
          to="/staff-panel/my-payslips"
          className="inline-flex items-center text-body-sm font-semibold text-neutral-500 dark:text-neutral-400 hover:text-primary-600 transition-colors mb-2"
        >
          <ArrowLeft className="h-3.5 w-3.5 mr-1" /> My Payslips
        </Link>
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
          <h1 className="text-title-lg md:text-headline-lg font-display font-bold text-neutral-900 dark:text-neutral-100 tracking-tight">
            {MONTHS[payslip.month]} {payslip.year} Payslip
          </h1>
          <div className="shrink-0">
            <PaymentStatusBadge status={payslip.paymentStatus} />
          </div>
        </div>
      </div>

      {/* Main Breakdown Display */}
      <Card>
        <CardContent className="p-6">
          <PayslipBreakdown payslip={payslip} />
        </CardContent>
      </Card>
    </div>
  );
}